import React, { useState, useEffect } from 'react';
import {
    Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TablePagination, Paper, Pagination, Icon,
    Dialog, DialogTitle, DialogContent,
    DialogActions, Button, TextField, CircularProgress
} from '@mui/material';
import { FileDownload } from '@mui/icons-material';
import axios from 'axios';
import * as common from '../../../commons/common';
import SearchArea from '../../../components/managerPage/searchArea';

// 경희대 pdf 양식2 - 기타시설 자체 안전검사표
const CheckReport2 = () => {
    const today = new Date().toISOString().substring(0, 10);
    const [facilityTypes, setFacilityTypes] = useState([]);
    const [list, setList] = useState([]);

    const [isDownloading, setIsDownloading] = useState(false);
    const [noteInput, setNoteInput] = useState('');
    const [expandedRow, setExpandedRow] = useState(null);

    const [searchParams, setSearchParams] = useState({
        facilityType: '',
        facilityNm: '',
        startDt: today,
        endDt: today,
        pageSize: '',
        page: '',
    });

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        getFacilityType()
    }, [])

    useEffect(() => {
        getCheckList();
    }, [page, rowsPerPage]);

    // 시설유형 리스트
    const getFacilityType = async () => {
        const url = `${common.getApiUrl()}/facility-type`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (response.data && Array.isArray(response.data)) {
                const fetchedItems = response.data.map((type) => ({
                    value: type.facilityTypeId,
                    label: type.facilityTypeNm,
                }));
                fetchedItems.unshift({ value: ' ', label: '선택' });
                setFacilityTypes(fetchedItems);
            }
        } catch (error) {
            console.error('데이터를 가져오는 데 실패했습니다:', error);
        }
    };

    const handleSearchParamChange = (name, value) => {
        setSearchParams({
            ...searchParams,
            [name]: value
        });
    };

    const handleSearchSubmit = () => {
        setPage(1);
        getCheckList();
    };

    // 점검 기록 리스트 조회
    const getCheckList = async () => {
        const url = `${common.getApiUrl()}/pdf/facility-checkList`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    facilityTypeId: searchParams.facilityType,
                    facilityNm: searchParams.facilityNm,
                    startCheckTime: searchParams.startDt,
                    endCheckTime: searchParams.endDt,
                    pageSize: rowsPerPage,
                    page: page
                }
            });

            setList(response.data.content);
            setTotalElements(response.data.totalElements);

        } catch (error) {
            console.error('데이터를 가져오는 데 실패했습니다:', error);
            setList([]);
            setTotalElements(0);
        }
    };

    // 행 확장 처리
    const handleExpandRow = (item) => {
        if (expandedRow === item.checkRsltMstrId) {
            setExpandedRow(null);
            setNoteInput('');
        } else {
            setExpandedRow(item.checkRsltMstrId);
            setNoteInput('');
        }
    };

    // PDF 다운로드 함수 수정
    const handlePdfDownload = async (item) => {
        setIsDownloading(true);
        const url = `${common.getApiUrl()}/pdf/facility-checkRslt/${item.checkRsltMstrId}`;
        const token = localStorage.getItem('access_token');

        const noteList = noteInput
            .split('\n')
            .filter(note => note.trim() !== '')
            .join('|');

        try {
            const params = {
                facilityTypeId: item.facilityTypeId,
            };

            if (noteList) {
                params.note = noteList;
            }

            const response = await axios.post(url, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = '기타시설 자체 안전검사표.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
            setExpandedRow(null);
            setNoteInput('');
        } catch (error) {
            console.error('PDF 다운로드 실패:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(1);
    };

    return (
        <>
            <Box sx={{ width: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
                <SearchArea
                    searchValues={{ facilityType: searchParams.facilityType, facilityNm: searchParams.facilityNm, startDt: searchParams.startDt, endDt: searchParams.endDt }}
                    handleSearchChanges={(name, value) => { handleSearchParamChange(name, value); }}
                    fields={[
                        {
                            fieldnm: '시설유형',
                            name: 'facilityType',
                            type: 'select',
                            options: facilityTypes
                        },
                        {
                            fieldnm: '시설명',
                            name: 'facilityNm',
                            type: 'input',
                        },
                        {
                            fieldnm: '점검일',
                            name: 'startDt',
                            type: 'calendar',
                        },
                        {
                            fieldnm: '~',
                            name: 'endDt',
                            type: 'calendar',
                        }
                    ]}
                    onSearchClick={handleSearchSubmit}
                />
                <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '10px', padding: '15px 10px' }}>
                    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#F2F2F2' }}>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>시설유형</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>시설명</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>점검자</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>점검일</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%' }}>PDF 다운로드</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.length > 0 ? (
                                    list.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow sx={{ 
                                                height: '52px',
                                                '& td': {
                                                    borderBottom: expandedRow === item.checkRsltMstrId ? 'none' : undefined,
                                                }
                                            }}>
                                                <TableCell align="center" sx={{padding:'4px'}}>{item.facilityTypeNm}</TableCell>
                                                <TableCell align="center" sx={{padding:'4px'}}>{item.facilityNm}</TableCell>
                                                <TableCell align="center" sx={{padding:'4px'}}>{item.checkerNm}</TableCell>
                                                <TableCell align="center" sx={{padding:'4px'}}>{item.checkTime}</TableCell>
                                                <TableCell align="center" sx={{padding:'4px'}}>
                                                    <Icon
                                                        onClick={() => handleExpandRow(item)}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        {isDownloading && expandedRow === item.checkRsltMstrId ?
                                                            <CircularProgress size={24} /> :
                                                            <FileDownload />
                                                        }
                                                    </Icon>
                                                </TableCell>
                                            </TableRow>
                                            {expandedRow === item.checkRsltMstrId && (
                                                <TableRow>
                                                    <TableCell colSpan={5} sx={{ padding: '16px' }}>
                                                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                                                                <TextField
                                                                    multiline
                                                                    rows={3}
                                                                    variant="outlined"
                                                                    placeholder="비고"
                                                                    value={noteInput}
                                                                    onChange={(e) => setNoteInput(e.target.value)}
                                                                />
                                                                <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', marginTop: '7px' }}>
                                                                    * 엔터키로 구분된 리스트 형식으로 출력됩니다.
                                                                </Box>
                                                            </Box>
                                                            <Button
                                                                variant="contained"
                                                                onClick={() => handlePdfDownload(item)}
                                                                disabled={isDownloading}
                                                                disableRipple
                                                                disableElevation
                                                                sx={{ 
                                                                    '&:hover': { backgroundColor: '#1E88E5' }
                                                                }}
                                                            >
                                                                {isDownloading ? "다운로드 중..." : "다운로드"}
                                                            </Button>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <TableRow sx={{ height: '52px' }}>
                                        <TableCell colSpan={5} align="center">
                                            검색된 데이터가 없습니다.
                                        </TableCell>
                                    </TableRow>
                                )}
                                {Array.from({ length: Math.max(rowsPerPage - (list.length || 1), 0) }).map((_, index) => (
                                    <TableRow key={`empty-row-${index}`} sx={{ height: '54px' }}>
                                        <TableCell colSpan={5} sx={{ padding: '8px' }} />
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2, }}>
                        <Box>
                            <Pagination
                                count={Math.ceil(totalElements / rowsPerPage)}
                                page={page}
                                onChange={(event, newPage) => handleChangePage(event, newPage)}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                        <Box sx={{ position: 'absolute', top: 5, left: 0 }}>
                            <TablePagination
                                labelDisplayedRows={() => ''}
                                component="div"
                                page={page - 1}
                                count={totalElements}
                                rowsPerPageOptions={[10, 25, 50]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                ActionsComponent={() => null}
                                onPageChange={() => null}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </>
    )
}

export default CheckReport2;